import useFormContext from "../../../hooks/useFormContext"
import React from "react";
import HeroStripeWrapper from "../../../ass_components/payment-components/HeroStripeWrapper";
import {Link} from 'react-router-dom';
import {translate} from "../../../i18n";
import {useDispatch, useSelector} from "react-redux";

const OptIn = () => {

    const { data, handleChange, errors} = useFormContext()
    const dispatch = useDispatch();
    const language_code = useSelector(state => state.lang);
    const iso2 = useSelector((s) => s.country.country?.value) || 'TG';
    const compantCountryCode = iso2.toLowerCase();

    const content = (
        <>
            <label htmlFor="optInAnnual">
                <input type="checkbox" id="optInAnnual" name="optInAnnual" checked={data.optInAnnual} onChange={handleChange} />
                {translate('signup', language_code.lang).optInAnnual}
            </label>
            <ul className="flex-col">
                <Link>En savoir plus sur les privileges</Link>
            </ul>
            <HeroStripeWrapper />
        </>
    )

    return content
}
export default OptIn